class TreatmentForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.formatOptionEls()
  }

  setupListeners () {
    super.setupListeners()

    this.selectEl = this.els?.select?.element
    this.buttonEl = this.els?.button?.element
    this.spaDetailsEls = this.els['spa-details']?.elements

    this.handleInput = this.handleInput.bind(this)
    this.handleButtonClick = this.handleButtonClick.bind(this)

    this.listeners.add(this.selectEl, 'input', this.handleInput)
    this.listeners.add(this.buttonEl, 'click', this.handleButtonClick)
  }

  handleInput (event) {
    const selectEl = event.target.closest(this.els.select.selector)
    const selectedOption = selectEl.options[selectEl.selectedIndex]

    const { url, variantId, name } = selectedOption.dataset

    if (!url || !variantId || !name) return

    this.updateSpaDetails(variantId)
    this.updateButton(url, name)
    this.updateUrl(variantId)
  }

  handleButtonClick () {
    if (this.buttonEl.disabled || !this.buttonEl.dataset.url) {
      return
    }

    // Tracking
    const trackingData = {
      event: 'TreatmentPDP_HeroBookTreatmentClick',
      treatment_title: this.dataset.productTitleHandle,
      treatment_id: this.dataset.productId,
      location_name: this.buttonEl.dataset.name,
    }
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ ...trackingData })

    window.open(this.buttonEl.dataset.url, '_blank')
  }

  updateSpaDetails (variantId) {
    this.spaDetailsEls.forEach(el => {
      el.setAttribute('aria-hidden', el.dataset.variantId !== variantId)
    })
  }

  updateButton (url, name) {
    this.buttonEl.innerText = this.buttonEl.dataset.selectedText
    this.buttonEl.setAttribute('data-url', url)
    this.buttonEl.setAttribute('data-name', name)
    this.buttonEl.disabled = false
  }

  updateUrl (variantId) {
    const url = new URL(window.location.href)

    url.searchParams.set('variant', variantId)

    window.history.replaceState({}, '', url.toString())
  }

  formatOptionEls () {
    this.selectEl = this.els?.select?.element
    if (!this.selectEl) return

    const preferredRegion = this.dataset.spaRegionPreference || ''
    const fallbackRegion =
      window.theme?.strings?.treatmentFormRegionFallback || 'Other'

    // Convert NodeList to array and exclude placeholder
    const optionEls = Array.from(
      this.selectEl.querySelectorAll('option'),
    ).filter(opt => opt.value !== '')

    // Group options by region
    const regionMap = optionEls.reduce((acc, opt) => {
      const region = opt.getAttribute('data-sort-region') || fallbackRegion
      if (!acc[region]) acc[region] = []
      acc[region].push(opt)
      return acc
    }, {})

    // Alphabetize options within each region,
    // then move institute items to the top
    for (const region in regionMap) {
      regionMap[region].sort((a, b) =>
        a.textContent.localeCompare(b.textContent),
      )

      // Secondary sort: institutes first
      regionMap[region].sort((a, b) => {
        const aIsInstitute = a.dataset.isInstitute === 'true'
        const bIsInstitute = b.dataset.isInstitute === 'true'

        if (aIsInstitute === bIsInstitute) return 0
        return aIsInstitute ? -1 : 1
      })
    }

    // Reorder regions
    let regionOrder = Object.keys(regionMap)
      .filter(r => r !== fallbackRegion) // exclude fallback for now
      .sort() // alphabetically

    // Order preferred region to first, if it exists
    if (
      preferredRegion &&
      regionMap[preferredRegion] &&
      preferredRegion !== fallbackRegion
    ) {
      regionOrder = [
        preferredRegion,
        ...regionOrder.filter(r => r !== preferredRegion),
      ]
    }

    // Add fallback region at the end, if it exists
    if (regionMap[fallbackRegion]) regionOrder.push(fallbackRegion)

    // Clear existing options and add placeholder
    this.selectEl.innerHTML = `<option value="" disabled selected>${window.theme.strings.treatmentFormMakeSelection}</option>`

    // Append grouped options with headers
    regionOrder.forEach(region => {
      const headerOption = document.createElement('option')
      headerOption.textContent = `— ${region} –`
      headerOption.disabled = true
      headerOption.style.fontWeight = 'bold'
      this.selectEl.appendChild(headerOption)

      regionMap[region].forEach(opt => this.selectEl.appendChild(opt))
    })
  }
}

if (!customElements.get('treatment-form')) {
  customElements.define('treatment-form', TreatmentForm, {
    extends: 'form',
  })
}
